import {
  Cached,
  Mapper,
  VersionMapper,
  FirestoreEntity,
  getFirestoreEntityVersionFn,
  ChainedMapper,
} from '../@harmony';
import { Album } from './domain/models/album.model';
import { AlbumDto, AlbumEntity, AnyAlbumEntityVersion } from './data/entities/album.entity';
import {
  AlbumDtoToAlbumEntityMapper,
  AlbumEntityToAlbumMapper,
} from './domain/mappers/album.mapper';
import { SharingResultDto } from './data/entities/sharing-result.dto';
import { SharingResult } from './domain/models/sharing-result.model';
import { SharintResultDtoToSharingResultMapper } from './domain/mappers/sharing-result.mapper';

export abstract class AlbumCommonProvider {
  abstract provideAlbumEntityVersionsMapper(): Mapper<
    FirestoreEntity<AnyAlbumEntityVersion>,
    FirestoreEntity<AlbumEntity>
  >;
  abstract provideAlbumDtoToAlbumMapper(): Mapper<AlbumDto, Album>;
  abstract provideAlbumEntityToAlbumMapper(): Mapper<FirestoreEntity<AnyAlbumEntityVersion>, Album>;
  abstract provideSharingResultDtoToSharingResultMapper(): Mapper<SharingResultDto, SharingResult>;
}

export class AlbumCommonDefaultProvider implements AlbumCommonProvider {
  @Cached()
  public provideAlbumEntityVersionsMapper(): Mapper<
    FirestoreEntity<AnyAlbumEntityVersion>,
    FirestoreEntity<AlbumEntity>
  > {
    return new VersionMapper(getFirestoreEntityVersionFn, []);
  }

  @Cached()
  public provideAlbumDtoToAlbumMapper(): Mapper<AlbumDto, Album> {
    return new ChainedMapper<[AlbumDto, FirestoreEntity<AlbumEntity>, Album]>([
      new AlbumDtoToAlbumEntityMapper(),
      new AlbumEntityToAlbumMapper(),
    ]);
  }

  @Cached()
  public provideAlbumEntityToAlbumMapper(): Mapper<FirestoreEntity<AnyAlbumEntityVersion>, Album> {
    return new ChainedMapper([
      this.provideAlbumEntityVersionsMapper(),
      new AlbumEntityToAlbumMapper(),
    ]);
  }

  @Cached()
  public provideSharingResultDtoToSharingResultMapper(): Mapper<SharingResultDto, SharingResult> {
    return new SharintResultDtoToSharingResultMapper();
  }
}
